import { eventChannel } from "redux-saga"

export default function createChannel(subscribe) {
  return eventChannel(emitter => {
    setTimeout(() => {
      emitter(window.location)
    })

    return subscribe(({ location }) => {
      emitter(location)
    })
  })
}
